import * as React from "react";

function SvgArrowsLeftIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19 17" fill="none" {...props}>
      <path
        d="M8.083 1.833L1 8.917 8.083 16M18 1.833l-7.084 7.084L18 16"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgArrowsLeftIcon;
